var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-loader",style:(_vm.elementHeight)},[_c('loader-spinner',_vm._b({},'loader-spinner',[_vm.$attrs, _vm.$props],false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }